import { memo, useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { relatedMsgIdInfo } from './state';
import { useAtomValue } from 'jotai';
import { find } from 'lodash-es';
import { eventBus } from 'services/eventBus';
import { RightOutlined } from '@ant-design/icons';

export const MsgRelateTodo = memo((props: { msgId: string }) => {
  const { msgId } = props;
  const { t } = useTranslate();
  const info = useAtomValue(relatedMsgIdInfo);
  const match = useMemo(() => {
    return find(info, { msgId });
  }, [info, msgId]);

  if (!match) return null;
  return (
    <div
      className="text-[12px] cursor-pointer py-[4px] text-[var(--ant-primary-color)]"
      onClick={() => {
        eventBus.emit('RELATED_MSGID_OPEN_TODO', match);
      }}
    >
      {t('scene.chatWorkspace.taskTab.detail.action.viewRelatedTasks')}
      <RightOutlined
        style={{
          color: 'var(--ant-primary-color)',
          fontSize: '10px',
        }}
      />
    </div>
  );
});

MsgRelateTodo.displayName = 'MsgRelateTodo';
